import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../axiosInstance";

export interface CreateSetupIntentResponse {
  clientSecret: string;
  customerId: string;
}

export const useCreateSetupIntent = (
  options?: UseMutationOptions<
    CreateSetupIntentResponse,
    unknown,
    { userId: string },
    unknown
  >
) => {
  return useMutation({
    ...options,
    mutationFn: async ({ userId }: { userId: string }) => {
      const { data } = await axiosInstance.post<CreateSetupIntentResponse>(
        getAPIURL("/Billing/CreateSetupIntent"),
        { userId }
      );
      return data;
    },
  });
};
